import { render, staticRenderFns } from "./CianNewBuildingUpdateDialog.vue?vue&type=template&id=461fbe80&"
import script from "./CianNewBuildingUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./CianNewBuildingUpdateDialog.vue?vue&type=script&lang=js&"
import style0 from "./CianNewBuildingUpdateDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports